"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Badge = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@stitches/react");
var stitches_config_1 = require("../stitches.config");
var Text_1 = require("./Text");
var StyledBadge = (0, react_1.styled)("button", {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    alignContent: "center",
    padding: "2px 6px",
    width: "fit-content",
    borderRadius: stitches_config_1.theme.shape.borderRadius,
    border: "none",
    variants: {
        color: {
            gray: {
                background: stitches_config_1.theme.colors.gray3,
                color: stitches_config_1.theme.colors.gray12,
            },
            critical: {
                background: stitches_config_1.theme.colors.red3,
                color: stitches_config_1.theme.colors.red11,
            },
            warning: {
                background: stitches_config_1.theme.colors.yellow3,
                color: stitches_config_1.theme.colors.yellow11,
            },
            success: {
                background: stitches_config_1.theme.colors.green3,
                color: stitches_config_1.theme.colors.green11,
            },
            pink: {
                background: stitches_config_1.theme.colors.pink3,
                color: stitches_config_1.theme.colors.pink11,
            },
            purple: {
                background: stitches_config_1.theme.colors.purple3,
                color: stitches_config_1.theme.colors.purple11,
            },
            brand: {
                background: stitches_config_1.theme.colors.blue3,
                color: stitches_config_1.theme.colors.blue11,
            },
            custom: {
                background: "$$color",
            },
        },
    },
    defaultVariants: {
        color: "gray",
    },
});
var className = "badge";
function Badge(props) {
    var label = props.label, otherProps = __rest(props, ["label"]);
    return ((0, jsx_runtime_1.jsxs)(StyledBadge, __assign({}, otherProps, { css: { $$color: props.colorString }, color: props.colorString ? "custom" : props.color, className: "".concat(className, " ").concat(props.className) }, { children: [props.startIcon && props.startIcon, (0, jsx_runtime_1.jsx)(Text_1.Text, __assign({ variant: props.textVariant ? props.textVariant : "text-base" }, { children: props.label }))] })));
}
exports.Badge = Badge;
Badge.toString = function () { return ".".concat(className); };
//# sourceMappingURL=Badge.js.map